import React, {useEffect, useState} from "react";
import PropTypes from 'prop-types';
import { Button } from "react-bootstrap";
import { Translate } from "../Translator";
import DatasourceBaseOauth from "../Datasources/DatasourceBaseOauth.jsx";
import { IsEmptyString } from "../GeneralFunctions"


const DatasourceNeoCRM = (props) => {
  
    const [mRepainter, SetRepainter] = useState(false)

    function SetTenantEnvironment(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.TenantEnvironment = aValue
        SetRepainter(!mRepainter)
    }

    function SetClientId(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.ClientId = aValue
        SetRepainter(!mRepainter)
    }

    function SetClientSecret(aValue)
    {
        props.IntegrationSettings.DatasourceSettings.ClientSecret = aValue
        SetRepainter(!mRepainter)
    }


    const BrandingId = sessionStorage.getItem("BrandingId")

    const BaseLoginUrl = !IsEmptyString(props.IntegrationSettings.DatasourceSettings.TenantEnvironment) ?
        "https://login-" + props.IntegrationSettings.DatasourceSettings.TenantEnvironment + ".xiaoshouyi.com/auc/oauth2/" :
        "https://login.xiaoshouyi.com/auc/oauth2/"
    const AuthUrl = BaseLoginUrl + "auth" +
        "?client_id=" + props.IntegrationSettings.DatasourceSettings.ClientId +
        "&response_type=code" +
        "&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2" +
        "&scope=all" +
        "&oauthType=standard" +
        "&access_type=offline"
    const TokenUrl = BaseLoginUrl + "token"
    const TokenBody = "grant_type=authorization_code" + 
        "&client_id=" + props.IntegrationSettings.DatasourceSettings.ClientId + 
        "&client_secret=" + props.IntegrationSettings.DatasourceSettings.ClientSecret + 
        "&redirect_uri=https://auth.cloudcti.nl/webapi/oauth2" +
        "&code=" 
    const TokenBodyType = "application/x-www-form-urlencoded"
    const TokenCodeInBody = true
    
    return <div className="scriptitembody">
        <div className="wizardfieldname">{Translate("Tenant environment").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.TenantEnvironment || ""} onChange={evt => SetTenantEnvironment(evt.target.value)} className="wizardinputfield"/></div>
        <div className="wizardfieldname">{Translate("Client ID").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.ClientId || ""} onChange={evt => SetClientId(evt.target.value)} className="wizardinputfield"/></div>
        <div className="wizardfieldname">{Translate("Client secret").toUpperCase()} <span className="redtext">*</span></div>
        <div className="wizardfieldvalue"><input autoComplete="new-password" type="text" value={props.IntegrationSettings.DatasourceSettings.ClientSecret || ""} onChange={evt => SetClientSecret(evt.target.value)} className="wizardinputfield"/></div>

        {IsEmptyString(props.IntegrationSettings.DatasourceSettings.TenantEnvironment) || IsEmptyString(props.IntegrationSettings.DatasourceSettings.ClientId) || IsEmptyString(props.IntegrationSettings.DatasourceSettings.ClientSecret) ?
            <Button disabled variant="primary" className={BrandingId === "enreach" ? "brandbuttonprimary" : "brandbuttonkeeporiginalstyle"} type="submit">{Translate("Connect")}</Button> :
            <DatasourceBaseOauth SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} TokenUrl={TokenUrl} TokenBody={TokenBody} TokenBodyType={TokenBodyType} TokenCodeInBody={TokenCodeInBody} OverrideName="NeoCRM" OnSetReady={props.OnSetReady}/>
        }
    </div>
}

DatasourceNeoCRM.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    Custom: PropTypes.bool, //ServiceNow specific
    OnSetReady: PropTypes.func
}   

export default DatasourceNeoCRM